import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    TabNavigationCtrlFilterPanel: {
        marginLeft: theme.sizes.spacing.default,
        marginRight: theme.sizes.spacing.default,
    },
    navigation: {
        display: 'flex',
        borderBottom: '2px #ccc solid',
        marginBottom: '7px',
    },
    navigationRoutes: {
        flex: 1,
    },
    navigationRoutesTabs: {
        width: '100%',
    },
    navigationRoutesTabsTab: {
        paddingTop: theme.sizes.spacing.minor,
        paddingBottom: theme.sizes.spacing.minor,
        fontWeight: 'bold',
        fontSize: '1rem',
    },
    navigationControls: {
        paddingLeft: theme.sizes.spacing.default,
    }
}));

export default useStyles;